import React from "react";
import Plans from "./components/Plans/Plans";
import WhoUsesAll3D from "./components/WhoUsesAll3D/WhoUsesAll3D";
import BrandsCarousel from "./components/BrandsCarousel/BrandsCarousel";
import Features from "./components/Features/Features";
import Enterprise from "./components/Enterprise/Enterprise";
import Faqs from "./components/Faqs/Faqs";
import ServiceAddOns from "./components/ServiceAddOns/ServiceAddOns";
import "./pricing.scss";

const Content = () => {
  return (
    <div className="mobile-top-margins" style={{ background: 'white'}}>
      <Plans />
      <ServiceAddOns/>
      <WhoUsesAll3D />
      <BrandsCarousel />
      <Features />
      <Enterprise />
      <Faqs />
    </div>
  );
};

export default Content;
